import { BaseService } from '@/infrastructure/api/base.service'
import type { NotificationDto } from '../types/notification-center.types'

/** The bell's backend (NotificationController), the same endpoints Vue 2's TopNavbar uses. */
export class NotificationCenterService extends BaseService {
	constructor() {
		super('/Notification')
	}

	/** The latest notifications for the signed-in user, newest first. */
	async getNotifications(take: number): Promise<NotificationDto[]> {
		const response = await this.get<unknown>('/GetNotifications', { params: { take } })
		// A login redirect comes back as an HTML page, not a list.
		if (!Array.isArray(response)) {
			throw new Error('The notifications response was not a list.')
		}
		return response as NotificationDto[]
	}

	async markAsRead(ids: string[]): Promise<void> {
		await this.post('/MarkAsRead', ids)
	}
}
